// @flow

import React, { PureComponent } from "react";
import type { Promo, RaceListItem } from "@tvg/types/Race";

import RaceInfoInline from "../../_molecule/RaceInfoInline";
import type { ImportanceType } from "../../_molecule/RaceLink";
import { Description, Empty, RaceInfoContainer } from "./styled-components";

type Props = {
  /**
   * highlighted description for the race
   */
  highlightedDescription: string,
  /**
   * style applyed to highlight
   */
  importanceLevel: ImportanceType,
  /**
   * Array with the relevant information for te race (distance, surface, purse, class, etc)
   */
  raceData: Array<RaceListItem>,
  /**
   * Text description of the race
   */
  description: string,
  /**
   * Should color of race info inline be greyDark
   */
  isGreyDarkText: boolean,
  /**
   * Hide Race Info
   */
  hideRaceInfo: boolean,
  /**
   * Promotions information
   */
  promo: Promo
};

export default class RaceInfo extends PureComponent<Props> {
  static defaultProps = {
    highlightedDescription: "",
    raceData: [],
    description: "",
    importanceLevel: "1",
    isGreyDarkText: false,
    hideRaceInfo: false,
    promo: null
  };

  render() {
    return (
      <RaceInfoContainer>
        {!this.props.hideRaceInfo && (
          <RaceInfoInline
            importanceLevel={this.props.importanceLevel}
            description={this.props.highlightedDescription}
            raceData={this.props.raceData}
            isGreyDarkText={this.props.isGreyDarkText}
            promo={this.props.promo}
            showPromoBadge
          />
        )}
        {this.props.description ? (
          <Description hasInfo={!this.props.hideRaceInfo}>
            {this.props.description}
          </Description>
        ) : (
          <Empty
            type="info"
            message="Details for this race are not available"
          />
        )}
      </RaceInfoContainer>
    );
  }
}
